import { DEFAULT_FEATURES_LIST, DEFAULT_GEO_FEATURES_LIST } from "constants/ml.constants";

import { IGroupByListItem } from "models/groupBy";

import { MlFeature, MlTarget, NormalizeFeaturePackage } from "./types";

export interface FeatureTemplate {
  name: string;
  features: MlFeature[];
  createdAt?: string;
  normalizationFeatures?: NormalizeFeaturePackage[];
  targetFeature?: MlTarget;
}

export const DEFAULT_TEMPLATE_NAME = "Default";

/**
 * Populates unit information for default features from the categoryList
 * @param categoryList - The categoryList from Redux state
 * @param includeGeoFeatures - Optional flag to include geo features (should be passed from component that has access to useUserModules)
 * @returns Array of MlFeatures with dynamically populated units
 */
export function getDefaultFeaturesWithUnits(
  categoryList: IGroupByListItem[],
  includeGeoFeatures = false
): MlFeature[] {
  const defaultList = includeGeoFeatures
    ? [...DEFAULT_FEATURES_LIST, ...DEFAULT_GEO_FEATURES_LIST]
    : DEFAULT_FEATURES_LIST;
  return defaultList.map((feature) => {
    // Find the category that matches the feature's category
    const category = categoryList.find((cat) => cat.name === feature.category);
    if (!category) {
      return { ...feature };
    }
    // Find the column that matches the feature's property
    const column = category.columns.find((col) => col.property === feature.Property);
    if (!column || !column.units) {
      return { ...feature };
    }
    return {
      ...feature,
      unit: column.units
    };
  });
}

export function getDefaultTemplate(
  categoryList: IGroupByListItem[],
  includeGeoFeatures = false
): FeatureTemplate {
  return {
    name: "Default",
    features: getDefaultFeaturesWithUnits(categoryList, includeGeoFeatures)
  };
}

// Export a static version without units for backward compatibility
export const DEFAULT_TEMPLATE_WITHOUT_UNITS: FeatureTemplate = {
  name: "Default",
  features: [...DEFAULT_FEATURES_LIST, ...DEFAULT_GEO_FEATURES_LIST] as MlFeature[]
};
